import { Component } from '@angular/core';
import {PermissionEnum} from "@app/enums/permissions/PermissionEnum";

@Component({
  selector: 'app-business-overview-sidebar',
  templateUrl: './business-overview-sidebar.component.html',
  styleUrl: './business-overview-sidebar.component.scss',
  standalone: false
})
export class BusinessOverviewSidebarComponent {

    protected readonly PermissionEnum = PermissionEnum;
}
